import {match, Pattern} from 'ts-pattern';

import {buildSortableItemId} from '@dms/features/dnd';

import {PHOTO_GUIDE_SLOT_DND_URL} from '../constants/PHOTO_GUIDE_SLOT_DND_URL';
import {PhotoGuideLayoutItem} from '../types/PhotoGuideLayoutItem';
import {buildPhotoGuideSlotDndId} from './buildPhotoGuideSlotDndId';

/**
 * A filled slot and an Extra Photo are identified by their photo, like any album tile, so a drag
 * into another album moves the photo. An empty slot is identified by its Photo Type.
 */
export const getPhotoGuideLayoutItemDndId = (
  item: PhotoGuideLayoutItem,
  saleVehicleAlbumId: string,
  index: number
) =>
  match(item)
    .with({kind: 'slot', image: Pattern.nullish}, (slot) =>
      buildSortableItemId(
        buildPhotoGuideSlotDndId(slot.photoType),
        saleVehicleAlbumId,
        PHOTO_GUIDE_SLOT_DND_URL,
        index
      )
    )
    .with({image: Pattern.nonNullable}, (filled) =>
      buildSortableItemId(filled.image.id, saleVehicleAlbumId, filled.image.url, index)
    )
    .exhaustive();
